"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajax = void 0;
const axios_1 = __importDefault(require("axios"));
const ajax = (url, type = 'GET') => {
    if (!url) {
        console.error('epic-common sso.get(url) requires a url parameter!');
    }
    //verify type if provided
    if (type) {
        const t = type.toUpperCase();
        if (t !== 'POST' && t !== 'GET' && t !== 'PUT' && t !== 'DELETE') {
            console.error(`epic-common sso.get() invalid HTTP method type: ${type}`);
        }
    }
    return axios_1.default({
        method: type,
        url
    }).then(response => {
        return response ? response.data : {};
    });
};
exports.ajax = ajax;
//# sourceMappingURL=ajax.js.map